var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._v(" Home :) "),_c('router-link',{attrs:{"to":"encrypt"}},[_vm._v("Make Your List!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }